/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
/* eslint-disable max-len */
import React, { useEffect } from 'react'
import {useContext ,useState} from "react"
import GlobalContext from '../../../../../../../components/Context/GloablContext'
import Pagination from '../../../../../../../components/Pagination'
import Limit from '../../../../../../../components/Limit'
import CustomOverLay from '../../../../../../../components/CustomOverLay'
import SearchEmptyScreen from '../../../../../../../components/SearchEmptyScreen'
import BloodGlouseVitalTable from './Components/Table'
import Emptyscreenwithouttitle from '../../../../../../../components/Emptyscreenwithouttitle'
import EnsureProperEncoding from '../../../../../../../CommonMethods/EnsureProperEncoding'

export default function BloodGlouseVitalList({
    data,
    isFetching,
    status,
    searchParams,
    setSearchParams,
    suggestions,
    handleSearchParams,
    vitalTabName,
    isColumnSelect,
    setStateLoading
}) {

    const {isSideBar} = useContext(GlobalContext);
    const [limit,setLimit]=useState("15")
    const [isSortselected, setisSortSelected] = useState(false)


    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        params['last_id']=null
        params['last_sort_value']=null
        params['last_page'] =null

        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        // setSearchParams({ ...params, page_number: pageNum,last_id:(pageNum===1?null:searchParams?.get('page_number')>pageNum?(data?.historical_reading?.[0]?._id!==undefined?data?.historical_reading?.[0]?._id:null):(data?.historical_reading?.[data?.historical_reading?.length-1]?._id!==undefined?data?.historical_reading?.[data?.historical_reading?.length-1]?._id:null)),last_page:(pageNum===1?null:searchParams?.get('page_number')>pageNum?searchParams?.get('page_number'):searchParams?.get('page_number')) })


        let keysort = decodeURIComponent(searchParams.get('sort')?.split('+')[0]);

        if (searchParams?.get('sort') !== null) {
        params.last_sort_value = EnsureProperEncoding(
            pageNum === 1
            ? null
            : searchParams?.get('page_number') > pageNum
            ? data?.historical_reading?.[0]?.[keysort] !== undefined
                ? data?.historical_reading?.[0]?.[keysort]
                : null
            : data?.historical_reading?.[data?.historical_reading?.length - 1]?.[keysort] !== undefined
            ? data?.historical_reading?.[data?.historical_reading?.length - 1]?.[keysort]
            : null
        );
        }

        const lastId = pageNum === 1 ? null :
            (searchParams?.get('page_number') > pageNum ?
                (data?.historical_reading?.[0]?._id !== undefined ? data?.historical_reading?.[0]?._id : null) :
                (data?.historical_reading?.[data?.historical_reading?.length - 1]?._id !== undefined ? data?.historical_reading?.[data?.historical_reading?.length - 1]?._id : null));
      
        const lastPage = pageNum === 1 ? null :
            (searchParams?.get('page_number') > pageNum ? searchParams?.get('page_number') : searchParams?.get('page_number'));
        setSearchParams({ ...params, page_number: pageNum, last_id: lastId, last_page: lastPage });
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
        //  setSearchParams({ ...params, page_number: pageNum})
    }
 
    useEffect(() => {
        // Set isStateLoading to true if any of the loading states are true
        if (status!=="fulfilled") {
            setStateLoading(true);
        } else {
            // Set isStateLoading to false only when all loading states are false
            setStateLoading(false);
        }
    }, [status]);
    return (
        <div className='bg-[#F9F3F5] h-full w-full overflow-x-hidden'>
            <div className='bg-white rounded-lg pt-3 h-[calc(100vh-337px)] relative'>
                <div className="px-11">
                    
                </div>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected" && !isSortselected)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text={`Loading ${vitalTabName} Device Reading History...`} classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'h-[calc(100vh-338px)]':'h-[calc(100vh-338px)]'}`}/>: (data!==undefined && data?.historical_reading?.length > 0 ) ? <>   
                    <BloodGlouseVitalTable
                        pageNumber={Number(searchParams.get('page_number')) || 1}
                        List={data}
                        vitalTabName={vitalTabName}
                        handleSearchParams={handleSearchParams}
                        sortValue={searchParams.get('sort') || ''}
                        setisSortSelected={setisSortSelected}
                    />
                    {data?.total_count>=15&&<div className="w-full px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-lg">
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}IsColumnSelect
                                isColumnSelect={isColumnSelect}
                            />
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </>:<>
                    {data?.historical_reading?.length===0 && (suggestions!==""||searchParams.get("field")!==null||searchParams.get("action")!==null||searchParams.get("start_date")!==null||searchParams.get("end_date")!==null) ?
                        <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria"} />
                        :
                        data?.total_count===0&&!searchParams.get("search")?<Emptyscreenwithouttitle
                            FirstPTag={"No device reading history to view yet"}
                            vitalHeight={true}
                        />:((status==="rejected"||(data?.total_count!==0&&data?.historical_reading?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                    }
                </>}

            </div>
        </div>
    )
}
